import { render, staticRenderFns } from "./OngoingInvestigation.vue?vue&type=template&id=14d42333&scoped=true&"
import script from "./OngoingInvestigation.vue?vue&type=script&lang=ts&"
export * from "./OngoingInvestigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d42333",
  null
  
)

export default component.exports